export const headers = [
  { content: "" },
  { content: "Member" },
  { content: "Role" },
  { content: "Role Category" },
  { content: "User Type" },
  { content: "Plans" },
  { content: "Assigned Actions" },
  { content: "Engagement" }
];

export const propertyPlansHeader = [
  { content: "" },
  { content: "Plan Name", isSorting: true },
  { content: "Customized" },
  { content: "Owner" },
  { content: "Plan Source" },
  { content: "Functional Area" },
  { content: "Priority", isSorting: true },
  { content: "Due Date", isSorting: true },
  { content: "Status" }
];
